'use client';

import React, { useEffect, useState } from "react";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import DetailRankingTable from "@/components/client/DetailRankingTable";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import MatchServices from "@/services/MatchServices";
import NoData from "@/components/client/NoData";
import LoadingInner from "@/app/loadingInner";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;

const MatchRanking = ({ matchId }) => {
  const [match, setMatch] = useState(null);
  const [standing, setStanding] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatchAndStanding = async () => {
      try {
        const matchData = await MatchServices.getMatchById(matchId);
        setMatch(matchData);

        if (matchData) {
          const { leagueId, homeId, awayId } = matchData;
          if (leagueId && homeId && awayId) {
            const standingData = await MatchServices.getMatchStanding(
              leagueId,
              homeId,
              awayId
            );
            setStanding(standingData);
          }
        }
      } catch (error) {
        console.error("Error fetching match or standing data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchAndStanding();
  }, [matchId]);

  if (loading) {
    return (
      <CollapsiblePanel
        title="Bảng Xếp Hạng"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <LoadingInner />
      </CollapsiblePanel>
    );
  }

  if (!match || !standing || standing?.statusCode === 404) {
    return null; // Nothing to render
  }

  if (
    !standing?.totalStandings?.length ||
    !standing?.homeStandings?.length ||
    !standing?.awayStandings?.length ||
    !standing?.halfStandings?.length
  ) {
    return (
      <CollapsiblePanel
        title="Bảng Xếp Hạng"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <NoData />
      </CollapsiblePanel>
    );
  }

  const home = {
    id: match.homeId,
    name: match.homeTeam.name,
    logo: match.homeTeam.logo,
  };

  const away = {
    id: match.awayId,
    name: match.awayTeam.name,
    logo: match.awayTeam.logo,
  };

  return (
    <CollapsiblePanel
      title="Bảng Xếp Hạng"
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      <DetailRankingTable home={home} away={away} standing={standing} />
    </CollapsiblePanel>
  );
};

export default MatchRanking;
